export const PotentialRepeatReportAction = {
  CREATE_TASK: "Create Client Task",
  CREATE_PROJECT: "Create Project",
  COPY_PRESENTATION: "Copy Presentation",
  COPY_SALES_ORDER: "Copy Sales Order",
  DISMISS: "Dismiss",
  UNDO_DISMISS: "Undo Dismiss",
} as const;

export type ActionType =
  (typeof PotentialRepeatReportAction)[keyof typeof PotentialRepeatReportAction];
